import React, { useState } from "react";
import { Play } from "lucide-react";
import { useLocation } from "react-router-dom";
import styles from "./components/Css/EpisodeCard.module.css";
import HowlerPlayer from "../components/audio/howlerPlayer/Howlerplayer";

const EpisodeCardd = () => {
  const location = useLocation();
  const { audioData } = location.state || {};
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);

  console.log("Received audioData in EpisodeCard:", audioData);

  if (!audioData) {
    return <div className={styles.loading}>Loading episode information...</div>;
  }

  const handleListenNow = () => {
    setShowPlayer(true);
    setIsPlaying(true);
  };

  const handleClosePlayer = () => {
    setShowPlayer(false);
    setIsPlaying(false);
  };

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const audioPlayerData = {
    id: audioData.id,
    title: audioData.title,
    author: audioData.created_by,
    song_url: audioData.audio_url,
    image: audioData.image || audioData.computer_image_url || audioData.mobile_image_url,
    duration: audioData.duration,
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.imageSection}>
          <img
            src={audioData.image}
            alt="Episode Cover"
            className={styles.coverImage}
          />
        </div>
        <div className={styles.contentSection}>
          <h1 className={styles.title}>{audioData.title}</h1>
          <div className={styles.metadataSection}>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Duration:</span>
              <span className={styles.metadataValue}>{formatDuration(audioData.duration)}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Genre:</span>
              <span className={styles.metadataValue}>{audioData.genre_name}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Language:</span>
              <span className={styles.metadataValue}>{audioData.language}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Views:</span>
              <span className={styles.metadataValue}>{audioData.views_count}</span>
            </div>
          </div>
          <p className={styles.description}>{audioData.description}</p>
          <button className={styles.button} onClick={handleListenNow}>
            <Play size={24} />
            Listen Now
          </button>
        </div>
      </div>
      {showPlayer && (
        <HowlerPlayer
          audio={audioPlayerData}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          onClose={handleClosePlayer}
        />
      )}
    </div>
  );
};

export default EpisodeCardd;
